'use client';

import useEligibleUSPayment from './useEligibleUSPayment';

const useDisplayAffirm = (): boolean => {
  return useEligibleUSPayment();
};

export default useDisplayAffirm;
